// Апселл «Отключить рекламу». Использует тот же компонент, что и модалка
// привязки устройства / премиума (account-modal-split) — единый визуальный язык:
// QR слева, инфо справа, без собственной панели (фон даёт сам модал).
let html = `<div class="account-modal-split account-modal-split--ad">
    <div class="account-modal-split__qr">
        <div class="account-modal-split__qr-code"></div>
        <div class="account-modal-split__qr-text">#{premium_scan_qr}</div>
    </div>

    <div class="account-modal-split__info">
        <div class="account-modal-split__title" style="font-weight: 600;">#{ad_qr_title}</div>
        <div class="account-modal-split__price">#{ad_fork_paid_title}</div>
        <div class="account-modal-split__price-day">#{ad_fork_paid_day}</div>
        <div class="account-modal-split__text">#{ad_qr_text}</div>
        <a class="account-modal-split__bot-link" target="_blank" rel="noopener"></a>
        <div class="account-modal-split__note">#{ad_fork_note}</div>
    </div>
</div>`

export default html
